<div class="header">
    <a class="return-link" href="https://cof.org/" target="_blank">
        <img class="arrow" src="assets/images/arrow-enter.svg" alt="Arrow">
        <span class="text">RETURN TO MAIN SITE</span>
    </a>
</div>
